/**
 * Shared corner-radius roles for stacked focus tracks (Live Topics, Personas, …).
 *
 * Two intentional shapes stay distinct: labeled pills vs thin interval bars.
 * Empty hatched bands share one radius so vacant tracks feel related.
 */

/** Near-capsule radius for labeled track pills (e.g. Live Topics). */
export const TRACK_LABELED_PILL_RADIUS_PX = 12;

/**
 * Soft rectangle for thin presence / interval bars (e.g. Personas appearances).
 * Keep well under half the bar height so short segments do not become dots.
 */
export const TRACK_INTERVAL_BAR_RADIUS_PX = 4;

/** Slightly tighter radius for compact mini-timeline interval bars. */
export const TRACK_MINI_INTERVAL_BAR_RADIUS_PX = 3;

/** Shared radius for empty hatched bands on focus tracks. */
export const TRACK_EMPTY_BAND_RADIUS_PX = 8;
